import React from 'react';
import './Header.css';

function Header() {
  return (
    <div>
      <h1>Digital Satsang Bhajan Collection Platform</h1>
    </div>
  );
}

export default Header;
